export const reviewTimeline = [
  {
    date: "09-03",
    stage: "起点",
    title: "一条匿名爆料开始扩散",
    desc: "最早的版本只有两张模糊截图，转发量不大，但用词极其具体，埋下了后续所有争论的种子。",
    tone: "start",
  },
  {
    date: "09-05",
    stage: "发酵",
    title: "当事人首次回应，反而点燃第二波",
    desc: "回应里对关键细节避而不谈，被网友逐字比对后形成新的质疑清单，话题首次进入热榜前列。",
    tone: "rise",
  },
  {
    date: "09-07",
    stage: "反转",
    title: "第三方材料出现，时间线出现缺口",
    desc: "一份平台后台记录显示，被指发生在当天的事件其实并非同一日期，舆论第一次出现明显分歧。",
    tone: "turn",
  },
  {
    date: "09-09",
    stage: "对撞",
    title: "两派各自拿出证据，越辩越乱",
    desc: "支持与质疑两方各执一词，讨论从事实层面滑向立场层面，情绪开始盖过信息。",
    tone: "clash",
  },
  {
    date: "09-11",
    stage: "降温",
    title: "关键一方停止更新，话题热度见顶回落",
    desc: "在热度最高点时选择沉默，反而让复盘者拿到了一个相对干净的观察窗口。",
    tone: "cool",
  },
  {
    date: "09-12",
    stage: "复盘",
    title: "把全部公开信息放回同一条轴",
    desc: "这正是黑料看点做的事：不站队，先把每一句话的出处、时间和语境对齐，再看谁在什么时候改变了说法。",
    tone: "end",
  },
];